import { Suspense } from "react";
import { Routes, Route, useLocation } from "react-router-dom";

import lazyWithRetry from "../utils/lazy";
import Loader from "../components/Loader";
import { getSalesChannel } from "../utils/jwt";

const Home = lazyWithRetry(() => import("../pages/Home"));
const Pages = lazyWithRetry(() => import("../pages/Pages"));
const UacPage = lazyWithRetry(() => import("../pages_web/UacPage"));
const BlogPage = lazyWithRetry(() => import("../pages_web/BlogPage"));
const BlogsPage = lazyWithRetry(() => import("../pages_web/BlogsPage"));
const FeaturePage = lazyWithRetry(() => import("../pages/FeaturePage"));
const EBookPage = lazyWithRetry(() => import("../pages_web/EBookPage"));
const CheckoutPage = lazyWithRetry(() => import("../pages/CheckoutPage"));
const SignInPage = lazyWithRetry(() => import("../pages_web/SignInPage"));
const WebinarPage = lazyWithRetry(() => import("../pages_web/WebinarPage"));
const FounderPage = lazyWithRetry(() => import("../pages_web/FounderPage"));
const ProductPage = lazyWithRetry(() => import("../pages_web/ProductPage"));
const CharityPage = lazyWithRetry(() => import("../pages_web/CharityPage"));
const CalendarPage = lazyWithRetry(() => import("../pages_web/CalendarPage"));
const ProtocolPage = lazyWithRetry(() => import("../pages_web/ProtocolPage"));
const FindAProPage = lazyWithRetry(() => import("../pages_web/FindAProPage"));
const PageNotFound = lazyWithRetry(() => import("../components/PageNotFound"));
const BecomeProPage = lazyWithRetry(() => import("../pages_web/BecomeProPage"));
const EducationPage = lazyWithRetry(() => import("../pages_web/EducationPage"));
const OnboardingPage = lazyWithRetry(() => import("../pages_web/OnboardingPage"));
const ResourceLibPage = lazyWithRetry(() => import("../pages_web/ResourceLibPage"));
const EducationList = lazyWithRetry(() => import("../components_web/EducationList"));
const Unsubscribe = lazyWithRetry(() => import("../components/products/Unsubscribe"));
const CreateAccountPage = lazyWithRetry(() => import("../pages_web/CreateAccountPage"));
const R3ModalIFramePage = lazyWithRetry(() => import("../pages_web/R3ModalIFramePage"));
const ResetPasswordPage = lazyWithRetry(() => import("../pages_web/ResetPasswordPage"));
const EducationDetail = lazyWithRetry(() => import("../components_web/EducationDetail"));
const REGENResourcesPage = lazyWithRetry(() => import("../pages_b2b/REGENResourcesPage"));
const ForgotPasswordPage = lazyWithRetry(() => import("../pages_web/ForgotPasswordPage"));
const AboutRegenRetailPage = lazyWithRetry(() => import("../pages_web/AboutRegenRetailPage"));

const ADMIN_URL = "https://admin.glymedplus.com";

const ExternalRedirectPage = ({ url }) => {
  window.location.replace(url);
  return null;
};

const WebRoutes = () => {
  const location = useLocation();
  const channel = getSalesChannel();
  const { backgroundLocation } = location.state || {};

  return (
    <>
      <Suspense fallback={<Loader style={{ minHeight: "100vh" }} />}>
        <Routes location={backgroundLocation || location}>
          <Route path="/" element={<Home />} />
          <Route path="products" element={<ProductPage />} />
          <Route path="checkout" element={<CheckoutPage />} />
          <Route path="uac" element={<UacPage />} />
          <Route path="founder" element={<FounderPage />} />
          <Route path="blogs" element={<BlogsPage />} />

          <Route path="blogs/:id" element={<BlogPage />} />
          {channel !== "school" && (
            <Route path="calendar/*" element={<CalendarPage />} />
          )}
          <Route path="protocols/*" element={<ProtocolPage />} />
          <Route path="webinars/*" element={<WebinarPage />} />
          <Route path="login" element={<SignInPage />} />
          <Route path="register-retail" element={<CreateAccountPage />} />
          <Route path="resources" element={<ResourceLibPage />} />
          <Route path="page/:pageId" element={<Pages />} />
          <Route path="page/:pageId/modal" element={<R3ModalIFramePage />} />
          <Route path="become-pro" element={<BecomeProPage />}>
            <Route path="/become-pro/:pageId" element={<R3ModalIFramePage />} />
          </Route>
          <Route path="forgot-password" element={<ForgotPasswordPage />} />
          <Route path="resetPassword/:token" element={<ResetPasswordPage />} />
          <Route path="unsubscribe" element={<Unsubscribe />} />
          <Route path="feature/:id" element={<FeaturePage />} />
          {channel !== "b2b" && (
            <Route path="locations" element={<FindAProPage />} />
          )}
          <Route path="regen-retail" element={<AboutRegenRetailPage />} />
          <Route
            path="gmp_admin/*"
            element={<ExternalRedirectPage url={ADMIN_URL} />}
          />
          <Route path="education" element={<EducationPage />}>
            <Route index element={<EducationList />} />
            <Route path=":id" element={<EducationDetail />} />
          </Route>
          <Route path="charity" element={<CharityPage />}></Route>
          <Route path="ebook" element={<EBookPage />} />
          <Route path="regen-resources" element={<REGENResourcesPage />} />
          <Route path="*" element={<PageNotFound />} />
          <Route path="onboarding" element={<OnboardingPage />} />
        </Routes>
      </Suspense>
    </>
  );
};

export default WebRoutes;
